// src/pages/Mapa.jsx
import React, { useEffect, useState, useRef } from "react";
import BottomNavigation from "../components/BottomNavigation";
import { useBottomSheet } from "../context/BottomSheetContext";
import { obtenerComerciosMapa, registrarTap, getCategorias } from "../api";
import quetzaltenangoGeoJSON from "../data/quetzaltenango.json";
import L from "leaflet";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import "leaflet/dist/leaflet.css";
import BottomSheetCategorias from "../components/BottomSheetCategorias";
import { motion } from "framer-motion";
import { useDynamicSplash } from "../hooks/useDynamicSplash";

const Mapa = () => {
  const { user } = useAuth();
  const [loadingMapa, setLoadingMapa] = useState(true);
  const showSplash = useDynamicSplash(loadingMapa);
  const [animacionTerminada, setAnimacionTerminada] = useState(false);
  const { openBottomSheet } = useBottomSheet();
  const [comerciosMapa, setComerciosMapa] = useState([]);
  const [comercioActivo, setComercioActivo] = useState(null);
  const [userLocation, setUserLocation] = useState(null);
  const mapRef = useRef(null);
  const markersLayer = useRef(L.layerGroup());
  const navigate = useNavigate();
  const [mapInstance, setMapInstance] = useState(null);
  const maxDistanciaKm = 5;
  const userMarkerRef = useRef(null);
  const [filtroCategoria, setFiltroCategoria] = useState(null);
  const categoriaSeleccionadaRef = useRef(null);
  const [mostrarCategorias, setMostrarCategorias] = useState(false); 
  const [showCategorias, setShowCategorias] = useState(false);
  const [categoriaActual, setCategoriaActual] = useState(null);
  const [usuarioMovioMapa, setUsuarioMovioMapa] = useState(false);
  const [idCategoriaSeleccionada, setIdCategoriaSeleccionada] = useState(null);
  const [categorias, setCategorias] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingCategorias, setLoadingCategorias] = useState(false);

  const handleCategorias = () => {
    setMostrarCategorias(true);
  };

  const quitarFiltro = async () => {
    categoriaSeleccionadaRef.current = null;
    setIdCategoriaSeleccionada(null);
    setCategoriaActual(null);
  
    // Coordenadas del usuario
    const lat = localStorage.getItem("userLat");
    const lng = localStorage.getItem("userLng");
  
    if (mapInstance && lat && lng) {
      const userLat = parseFloat(lat);
      const userLng = parseFloat(lng);
  
      // Hacer zoom y centrar en la ubicación del usuario
      mapInstance.setView([userLat, userLng], 15); // 👈 Zoom original
    }
  
    // Obtener comercios sin filtro (en el área visible actual)
    const bounds = mapInstance.getBounds();
  
    const ne = {
      lat: bounds.getNorthEast().lat,
      lng: bounds.getNorthEast().lng,
    };
    const sw = {
      lat: bounds.getSouthWest().lat,
      lng: bounds.getSouthWest().lng,
    };
  
    const data = await obtenerComerciosMapa(ne, sw);
  
    if (data.success) {
      const comerciosConDistancia = data.comercios.map((comercio) => {
        let distancia = "Ubicación desconocida";
        if (lat && lng && comercio.latitud && comercio.longitud) {
          const km = calcularDistanciaKm(
            parseFloat(lat),
            parseFloat(lng),
            parseFloat(comercio.latitud),
            parseFloat(comercio.longitud)
          );
          distancia = `${km} km`;
        }
        return { ...comercio, distancia };
      });
  
      setComerciosMapa(comerciosConDistancia);
      toast.dismiss();
      toast.success("Filtro eliminado.");
    }
  }; 

  const cargarCategorias = async () => {
    if (loadingCategorias || !hasMore) return;
    setLoadingCategorias(true);
  
    try {
      const res = await getCategorias(page);
      if (res.success && res.categorias.length > 0) {
        setCategorias(prev => {
          const todas = [...prev, ...res.categorias];
          const unicas = Array.from(new Map(todas.map(c => [c.id, c])).values());
          return unicas;
        });
  
        if (res.categorias.length < 30) setHasMore(false);
        else setPage(prev => prev + 1);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("❌ Error cargando categorías:", error);
    }
  
    setLoadingCategorias(false);
  };

  const actualizarComerciosPorCategoria = async (categoria) => {
    if (!mapInstance) return;
  
    categoriaSeleccionadaRef.current = categoria;
    setIdCategoriaSeleccionada(categoria);
    setCategoriaActual(categoria);
  
    // Usar bounds completos de Quetzaltenango
    const geoLayer = L.geoJSON(quetzaltenangoGeoJSON);
    const bounds = geoLayer.getBounds();
  
    const ne = {
      lat: bounds.getNorthEast().lat,
      lng: bounds.getNorthEast().lng,
    };
    const sw = {
      lat: bounds.getSouthWest().lat,
      lng: bounds.getSouthWest().lng,
    };
  
    // ✅ Llamar a la API ANTES de hacer fitBounds
    const data = await obtenerComerciosMapa(ne, sw, categoria);
  
    if (data.success) {
      const lat = localStorage.getItem("userLat");
      const lng = localStorage.getItem("userLng");
  
      const comerciosConDistancia = data.comercios.map((comercio) => {
        let distancia = "Ubicación desconocida";
        if (lat && lng && comercio.latitud && comercio.longitud) {
          const km = calcularDistanciaKm(
            parseFloat(lat),
            parseFloat(lng),
            parseFloat(comercio.latitud),
            parseFloat(comercio.longitud)
          );
          distancia = `${km} km`;
        }
        return { ...comercio, distancia };
      });
  
      if (comerciosConDistancia.length === 0) {
        markersLayer.current.clearLayers();
        setComerciosMapa([]);
        toast.dismiss();
        toast.error("No hay comercios en esta categoría para Quetzaltenango.");
        return;
      }
  
      setComerciosMapa(comerciosConDistancia);
  
      // ✅ Ahora sí hacemos el fitBounds DESPUÉS
      setTimeout(() => {
        mapInstance.fitBounds(bounds);
      }, 300);
    }
  };  

  const genero = localStorage.getItem("genero");

  

  let imagenGenero = "/assets/images/indefinido.png";
  if (genero === "masculino") imagenGenero = "/assets/images/masculino.png";
  else if (genero === "femenino") imagenGenero = "/assets/images/femenino.png";

  const userIcon = useRef(
    L.divIcon({
      html: `<div class="business-icon pulse"><img src="${imagenGenero}" style="width: 40px; height: 40px; border-radius: 50%;" alt="Foto de perfil" /></div>`,
      className: "",
      iconSize: [40, 40],
      iconAnchor: [20, 40],
    })
  );

  useEffect(() => {
    let mounted = true;

    const cargarInicial = async () => {
      setLoadingMapa(true);
      document.body.style.overflow = "hidden";

      try {
        const fetchComercios = await obtenerComerciosMapa();
        if (!mounted) return;

        if (fetchComercios.success) {
          const lat = localStorage.getItem("userLat");
          const lng = localStorage.getItem("userLng");

          const comerciosConDistancia = fetchComercios.comercios.map((comercio) => {
            let distancia = "Ubicación desconocida";
            if (lat && lng && comercio.latitud && comercio.longitud) {
              const km = calcularDistanciaKm(
                parseFloat(lat),
                parseFloat(lng),
                parseFloat(comercio.latitud),
                parseFloat(comercio.longitud)
              );
              distancia = `${km} km`;
            }
            return { ...comercio, distancia };
          });
          setComerciosMapa(comerciosConDistancia);
        }

        const lat = localStorage.getItem("userLat");
        const lng = localStorage.getItem("userLng");
        if (lat && lng) {
          setUserLocation({ lat: parseFloat(lat), lng: parseFloat(lng) });
        }
      } finally {
        if (mounted) {
          setLoadingMapa(false);
          document.body.style.overflow = "auto";
          window.scrollTo(0, 0);
        }
      }
    };

    cargarInicial();
    return () => {
      mounted = false;
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    if (!mapRef.current || !animacionTerminada || mapInstance) return;
  
    const map = L.map(mapRef.current); // No usamos setView aún
  
    L.tileLayer("https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
    }).addTo(map);
  
    const geoLayer = L.geoJSON(quetzaltenangoGeoJSON, {
      style: {
        color: "#007bff",
        weight: 2,
        fillColor: "#007bff55",
        fillOpacity: 0.4,
      },
      onEachFeature: function (feature, layer) {
        layer.bindPopup("Departamento de Quetzaltenango");
      },
    }).addTo(map);
  
    map.fitBounds(geoLayer.getBounds());
  
    const lat = localStorage.getItem("userLat");
    const lng = localStorage.getItem("userLng");

    if (lat && lng) {
      const userLat = parseFloat(lat);
      const userLng = parseFloat(lng);
    
      map.setView([userLat, userLng], 15);
    
      if (!userMarkerRef.current) {
        const marker = L.marker([userLat, userLng], {
          icon: userIcon.current,
        }).addTo(map);
        marker.bindPopup("Tu ubicación actual");
        userMarkerRef.current = marker;
      } else {
        userMarkerRef.current.setLatLng([userLat, userLng]);
      }
    
      setTimeout(() => {
        map.fire("moveend");
      }, 200);
    }
  
    /*if (lat && lng) {
      const userLat = parseFloat(lat);
      const userLng = parseFloat(lng);
  
      map.setView([userLat, userLng], 15);
  
      const userIcon = L.divIcon({
        html: `<div class="business-icon pulse"><img src="${imagenGenero}" style="width: 40px; height: 40px; border-radius: 50%;" alt="Foto de perfil" /></div>`,
        className: "",
        iconSize: [40, 40],
        iconAnchor: [20, 40],
      });
  
      L.marker([userLat, userLng], { icon: userIcon })
        .addTo(map)
        .bindPopup("Tu ubicación actual");

        setTimeout(() => {
          map.fire("moveend");
        }, 200);
    }*/
    
    setMapInstance(map);

    markersLayer.current.addTo(map);

    map.on("moveend", async () => {
      if (categoriaSeleccionadaRef.current) {
        return;
      }
    
      const bounds = map.getBounds();
      const neRaw = bounds.getNorthEast();
      const swRaw = bounds.getSouthWest();
    
      const ne = {
        lat: Math.max(neRaw.lat, swRaw.lat),
        lng: Math.max(neRaw.lng, swRaw.lng),
      };
      const sw = {
        lat: Math.min(neRaw.lat, swRaw.lat),
        lng: Math.min(neRaw.lng, swRaw.lng),
      };
    
      const data = await obtenerComerciosMapa(ne, sw);

      if (data.success) {
        const lat = localStorage.getItem("userLat");
        const lng = localStorage.getItem("userLng");
    
        const comerciosConDistancia = data.comercios.map((comercio) => {
          let distancia = "Ubicación desconocida";
          if (lat && lng && comercio.latitud && comercio.longitud) {
            const km = calcularDistanciaKm(
              parseFloat(lat),
              parseFloat(lng),
              parseFloat(comercio.latitud),
              parseFloat(comercio.longitud)
            );
            distancia = `${km} km`;
          }
          return { ...comercio, distancia };
        });
        setComerciosMapa(comerciosConDistancia);
      }
    });       
  
    setTimeout(() => {
      map.invalidateSize();
    }, 300);
  
    return () => {
      map.remove();
      setMapInstance(null);
    };
  }, [animacionTerminada]);
  

  useEffect(() => {
    if (!mapInstance || comerciosMapa.length === 0) return;
  
    markersLayer.current.clearLayers(); 
  
    comerciosMapa.forEach((comercio) => {
      const icon = L.icon({
        iconUrl: comercio.logo,
        iconSize: [45, 45],
        iconAnchor: [22, 45],
        className: "business-icon",
      });
  
      const marker = L.marker([comercio.latitud, comercio.longitud], { icon });
      marker.on("click", () => {
        setComercioActivo(comercio);
        mapInstance.setView([comercio.latitud, comercio.longitud], 16, { animate: true });
      });
  
      markersLayer.current.addLayer(marker);
    });
  
  }, [comerciosMapa, mapInstance]);

  const calcularDistanciaKm = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(lat1 * Math.PI / 180) *
        Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return (R * c).toFixed(2);
  };

  const aplicarFiltro = (catId) => {
    if (!catId) {
      toast.dismiss();
      toast.error("Selecciona una categoría primero");
      return;
    }
    const categoria = categorias.find((c) => c.id === catId);
    if (categoria && categoria.nombre) {
      setCategoriaActual(categoria.nombre);
    } else {
      setCategoriaActual(`Categoría ID ${catId}`);
    }
    setIdCategoriaSeleccionada(catId);
    actualizarComerciosPorCategoria(catId);
    categoriaSeleccionadaRef.current = catId;
    setMostrarCategorias(false);
  };  

  useEffect(() => {
    if (!mapInstance) return;
  
    // Detectar si el usuario mueve el mapa
    mapInstance.on("dragstart", () => setUsuarioMovioMapa(true));
  
    const interval = setInterval(() => {
      const lat = localStorage.getItem("userLat");
      const lng = localStorage.getItem("userLng");
  
      if (lat && lng) {
        const userLat = parseFloat(lat);
        const userLng = parseFloat(lng);
  
        // Crear o mover el marcador del usuario
        if (userMarkerRef.current) {
          userMarkerRef.current.setLatLng([userLat, userLng]);
        } else {
          const marker = L.marker([userLat, userLng], {
            icon: userIcon.current,
          }).addTo(mapInstance);
          marker.bindPopup("Tu ubicación actual");
          userMarkerRef.current = marker;
        }
  
        // Solo recentrar si el usuario no ha movido el mapa manualmente
        if (!usuarioMovioMapa && !comercioActivo) {
          mapInstance.setView([userLat, userLng]);
          mapInstance.fire("moveend");
        }
      }
    }, 20000); // cada 20 segundos
  
    return () => {
      clearInterval(interval);
      mapInstance.off("dragstart");
    };
  }, [mapInstance, comercioActivo, imagenGenero]);

  /*useEffect(() => {
    if (!mapInstance) return;
  
    const interval = setInterval(() => {
      const lat = localStorage.getItem("userLat");
      const lng = localStorage.getItem("userLng");
  
      if (lat && lng) {
        const userLat = parseFloat(lat);
        const userLng = parseFloat(lng);
  
        // Crear ícono personalizado
        const userIcon = L.divIcon({
          html: `<div class="business-icon pulse"><img src="${imagenGenero}" style="width: 40px; height: 40px; border-radius: 50%;" alt="Foto de perfil" /></div>`,
          className: "",
          iconSize: [40, 40],
          iconAnchor: [20, 40],
        });
  
        // Crear o actualizar marcador del usuario
        if (userMarkerRef.current) {
          userMarkerRef.current.setLatLng([userLat, userLng]);
        } else {
          const marker = L.marker([userLat, userLng], { icon: userIcon }).addTo(mapInstance);
          marker.bindPopup("Tu ubicación actual");
          userMarkerRef.current = marker;
        }
  
        // Mover el mapa si no está viendo detalle de comercio
        if (!comercioActivo) {
          mapInstance.setView([userLat, userLng], 15);
          mapInstance.fire("moveend"); // volver a disparar para que actualice comercios
        }
      }
    }, 20000); // cada 30 segundos
  
    return () => clearInterval(interval); // limpiar cuando se salga de la vista
  }, [mapInstance, comercioActivo, imagenGenero]);  */

  return (
    <>
      {showSplash && (
        <div id="splash">
          <img src="/assets/images/loading.gif" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}

      {!showSplash && (
        <motion.div
          initial={{ y: "100%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "100%", opacity: 0 }}
          transition={{ duration: 0.7, ease: "easeInOut" }}
          onAnimationComplete={() => setAnimacionTerminada(true)}
        >
          <div className="app-container">
            <header className="app-header other-map-h">
              <div className="left">
                <svg
                  id="open-search"
                  onClick={openBottomSheet}
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="m17 17l4 4M3 11a8 8 0 1 0 16 0a8 8 0 0 0-16 0"
                  />
                </svg>
              </div>
              <div className="center">
                <img src="/assets/images/logocap.png" alt="Ubikalo!" className="logo" />
              </div>
              <div className="right" onClick={() => setShowCategorias(true)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill="none" stroke="currentColor" strokeLinecap="round" stroke-miterlimit="10" strokeWidth="1" d="M21.25 12H8.895m-4.361 0H2.75m18.5 6.607h-5.748m-4.361 0H2.75m18.5-13.214h-3.105m-4.361 0H2.75m13.214 2.18a2.18 2.18 0 1 0 0-4.36a2.18 2.18 0 0 0 0 4.36Zm-9.25 6.607a2.18 2.18 0 1 0 0-4.36a2.18 2.18 0 0 0 0 4.36Zm6.607 6.608a2.18 2.18 0 1 0 0-4.361a2.18 2.18 0 0 0 0 4.36Z" />
              </svg>
              </div>
            </header>
            <div
              ref={mapRef}
              className="map-containers"
              style={{ height: "100vh", width: "100vw", zIndex: 0 }}
            />
            {comercioActivo && (
              <>
                <div
                  className="map-popup-overlay"
                  onClick={() => setComercioActivo(null)}
                ></div>
                <div className="map-popup-card">
                  <img src={comercioActivo.logo} onClick={() => {
                        const id_perfil = localStorage.getItem("id_perfil");
                        registrarTap(comercioActivo.id_sucursal, "mapa_general", id_perfil);                        
                        setTimeout(() => {
                          window.location.href = `/comercio/app/${comercioActivo.id_sucursal}`;
                        }, 200);
                      }} alt={comercioActivo.nombre} />
                  <div className="map-popup-content">
                    <h4>
                      {comercioActivo.nombre_comercio}
                      <img
                        src="/assets/images/verified.svg"
                        className="verifiedUser"
                        style={{ width: 300 }}
                        alt="Verificado"
                      />
                    </h4>
                    <p>
                      Estás a:{" "}
                      <span>
                        {comercioActivo.distancia || "Calculando distancia..."}
                      </span>
                    </p>
                    <button
                      className="map-popup-btn"
                      onClick={() => {
                        const id_perfil = localStorage.getItem("id_perfil");
                        registrarTap(comercioActivo.id_sucursal, "mapa_general", id_perfil);
                        
                        // Esperar unos milisegundos antes de redirigir
                        setTimeout(() => {
                          window.location.href = `/comercio/app/${comercioActivo.id_sucursal}`;
                        }, 200);
                      }}
                    >
                      Ir al perfil
                    </button>
                  </div>
                  <button
                    className="map-popup-close"
                    onClick={() => setComercioActivo(null)}
                  >
                    ×
                  </button>
                </div>
              </>
            )}
            {showCategorias && (
              <BottomSheetCategorias
                onClose={() => setShowCategorias(false)}
                onAplicar={aplicarFiltro}
                categoriaActual={categoriaActual}
                onQuitarFiltro={quitarFiltro}
              />
            )}
            <BottomNavigation />
          </div>
        </motion.div>
      )}
    </>
  );
};

export default Mapa;
